export default {
  CYBER_ATTESTATION: {
    licensingEntity: 'publicSector',
    action: '/cybersecurity',
    actionWord: 'Confirm',
  },
  TDLR_RENEWAL: {
    licensingEntity: 'tdlr',
    action: '/tdlrlr',
    actionWord: 'Renew',
  },
  DMV_RENEWAL: {
    licensingEntity: 'dmv',
    action: '/dmvrr',
    actionWord: 'Renew',
  },
  DLR_RENEWAL: {
    licensingEntity: 'dps',
    action: '/dpslr',
    actionWord: 'Renew',
  },
  TPWD_RENEWAL: {
    licensingEntity: 'tpwd',
    action: '/tpwdas',
    actionWord: 'Renew',
  },
};
